/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import ImmunizationIcon from 'icons/ImmunizationIcon';

const messages = defineMessages({
  title: {id: 'navigation.health-immunizations'},
});

const ImmunizationsItem = () => (
  <RouteLinkItem
    iconBefore={ImmunizationIcon}
    route="midas/students/health/immunizations"
    title={messages.title}
  />
);

export default ImmunizationsItem;
